module.exports = __webpack_public_path__ + "img/组 20.1c927f3c.png";